module.exports = __webpack_public_path__ + "media/images/Results-Positive-Antibodies-1247caec5bca4c4028bc9ccbb37da24a.png";